// extracted by mini-css-extract-plugin
export default {"cardBox":"CardBox_cardBox__J-rj0","title":"CardBox_title__1WA6c","content":"CardBox_content__b1AhL"};